// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__1peHY","contained":"OpenButton_contained__10Eup","disabled":"OpenButton_disabled__1xQIW","error":"OpenButton_error__tlcMP"};